var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4955_54914)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.934 9.8519C26.8406 9.85084 25.7922 9.41602 25.0191 8.64285C24.2459 7.86968 23.8111 6.82133 23.81 5.7279V0.00390625H5.38199C3.9546 0.00390625 2.58568 0.57094 1.57635 1.58026C0.567034 2.58958 0 3.95851 0 5.3859V37.8299C0.00211967 39.2559 0.570084 40.6228 1.57917 41.6304C2.58827 42.638 3.95598 43.2039 5.38199 43.2039H27.504C28.9304 43.2039 30.2984 42.6377 31.3075 41.6297C32.3167 40.6216 32.8844 39.2543 32.886 37.8279V9.8519H27.934Z",
    fill: "#00678E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.8861 9.8519H27.9341C26.8406 9.85084 25.7923 9.41602 25.0191 8.64285C24.2459 7.86968 23.8111 6.82133 23.8101 5.7279V0.00390625L32.8861 9.8519Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7879 34.1239H11.7799C10.0059 34.1239 8.56787 35.562 8.56787 37.3359V44.7919C8.56787 46.5659 10.0059 48.0039 11.7799 48.0039H36.7879C38.5618 48.0039 39.9999 46.5659 39.9999 44.7919V37.3359C39.9999 35.562 38.5618 34.1239 36.7879 34.1239Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8119 42.6779V44.1319H14.3059V42.6779H15.8119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0239 42.0239V44.1319H16.5679V38.1179H18.9239C19.6399 38.1179 20.1845 38.2952 20.5579 38.6499C20.7474 38.8358 20.8954 39.0597 20.9923 39.3068C21.0891 39.5539 21.1326 39.8188 21.1199 40.0839C21.1262 40.4337 21.0392 40.7789 20.8679 41.0839C20.6942 41.3825 20.4351 41.6221 20.1239 41.7719C19.7497 41.9504 19.3382 42.0368 18.9239 42.0239H18.0239ZM19.6399 40.0839C19.6399 39.5506 19.3479 39.2839 18.7639 39.2839H18.0239V40.8499H18.7639C19.3479 40.8552 19.6399 40.5999 19.6399 40.0839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.176 44.1319H25.722L23.286 40.4399V44.1319H21.832V38.1179H23.286L25.72 41.8439V38.1179H27.174L27.176 44.1319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.858 38.6039C33.3433 38.967 33.6694 39.5038 33.768 40.1019H32.228C32.127 39.8877 31.9648 39.7081 31.762 39.5859C31.5328 39.45 31.2703 39.3808 31.004 39.3859C30.7971 39.3773 30.5908 39.4143 30.3997 39.4941C30.2086 39.5739 30.0373 39.6947 29.898 39.8479C29.6058 40.1991 29.4572 40.6477 29.482 41.1039C29.482 41.6759 29.628 42.1152 29.92 42.4219C30.0841 42.5812 30.2797 42.7045 30.4943 42.7837C30.7089 42.8629 30.9377 42.8964 31.166 42.8819C31.4923 42.8875 31.8116 42.7872 32.076 42.5959C32.3453 42.3943 32.5396 42.1085 32.628 41.7839H30.792V40.7379H33.846V42.2039C33.7277 42.5616 33.5424 42.8935 33.3 43.1819C33.0382 43.4923 32.712 43.7421 32.344 43.9139C31.9268 44.1065 31.4714 44.2022 31.012 44.1939C30.4538 44.208 29.9017 44.0742 29.412 43.8059C28.9638 43.5546 28.5989 43.1778 28.362 42.7219C28.1085 42.2309 27.9813 41.6844 27.992 41.1319C27.98 40.5761 28.1072 40.026 28.362 39.5319C28.5985 39.0771 28.9619 38.7005 29.408 38.4479C29.8906 38.182 30.4351 38.0489 30.986 38.0619C31.6529 38.0292 32.3117 38.2199 32.858 38.6039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9399 13.3479H8.18994V16.0979H10.9399V13.3479Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6919 16.0979H10.9419V18.8479H13.6919V16.0979Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4419 13.3479H13.6919V16.0979H16.4419V13.3479Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1919 16.0979H16.4419V18.8479H19.1919V16.0979Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.946 13.3479H19.196V16.0979H21.946V13.3479Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.696 16.0979H21.946V18.8479H24.696V16.0979Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9399 18.8439H8.18994V21.5939H10.9399V18.8439Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6919 21.5939H10.9419V24.3439H13.6919V21.5939Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4419 18.8439H13.6919V21.5939H16.4419V18.8439Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1919 21.5939H16.4419V24.3439H19.1919V21.5939Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.946 18.8439H19.196V21.5939H21.946V18.8439Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.696 21.5939H21.946V24.3439H24.696V21.5939Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9399 24.3659H8.18994V27.1159H10.9399V24.3659Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6919 27.1159H10.9419V29.8659H13.6919V27.1159Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4419 24.3659H13.6919V27.1159H16.4419V24.3659Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1919 27.1159H16.4419V29.8659H19.1919V27.1159Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.946 24.3659H19.196V27.1159H21.946V24.3659Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.696 27.1159H21.946V29.8659H24.696V27.1159Z",
    fill: "#00678E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4955_54914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 48,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.1b7a3870d8740a4cb7db7c82b2f92907.svg";
export { ForwardRef as ReactComponent };